var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.7,16.5H40.1l0-0.9c0-2.8-2.2-5-5-5h-6.2c-2.8,0-5,2.2-5,5v0.9H11.3c-3.3,0-6.2,2.6-6.3,6 c-0.1,2.9,1.8,5.5,4.6,6.2l14.3,3.6v4.6c0,0.1,0,0.2,0,0.3l2.5,10.6l-4.9,3.6c-1,0.7-1.5,1.9-1.5,3.1c0,2.1,1.7,3.8,3.8,3.8H29 l0.4,1.6c0.3,1.2,1.4,2.1,2.6,2.1c1.2,0,2.3-0.8,2.6-2.1l0.4-1.6h4.6c2.1,0,3.8-1.7,3.8-3.9c0-1.2-0.5-2.3-1.5-3L37.5,48L40,37.8 c0.1-0.2,0.1-0.4,0.1-0.7l0-4.8l14.3-3.7c2.8-0.7,4.7-3.3,4.6-6.2C58.9,19.1,56.1,16.5,52.7,16.5z M10.4,25.8C9,25.4,8,24.1,8,22.7 c0-1.7,1.4-3.2,3.2-3.2h12.7v9.7L10.4,25.8z M23.9,56.3c-1,0-1.8-0.8-1.8-1.8c0-0.6,0.3-1.1,0.7-1.5l4.2-3.1l1.5,6.4L23.9,56.3 L23.9,56.3z M26.9,36.9V15.6c0-1.1,0.9-2,2-2h6.2c1.1,0,2,0.9,2,2v21.3L32,58.1L26.9,36.9z M40.7,53c0.4,0.4,0.7,0.9,0.7,1.5 c0,1-0.8,1.8-1.8,1.8h-4.1l1.5-6.2L40.7,53z M53.6,25.8l-13.5,3.5l0-9.7h12.7c1.7,0,3.2,1.4,3.2,3.2C56,24.1,55,25.4,53.6,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,8.9h29.7c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H36.4C35.7,3.2,34,2,32,2c-2,0-3.7,1.2-4.4,3H17.2 c-1.1,0-2,0.9-2,2C15.2,8,16,8.9,17.2,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,20.3c-2.4,0-4.3,1.9-4.3,4.3v5.4c0,2.4,1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3v-5.4C36.3,22.3,34.4,20.3,32,20.3 z M34.3,30.1c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-5.4c0-1.3,1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3V30.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviator);
export default __webpack_public_path__ + "static/media/aviator.974ace05c0f36f05a6a4b7b2677320fb.svg";
export { ForwardRef as ReactComponent };